import React from 'react';
import '../../styles/Habilidades.css';

export default function Habilidades() {
    return (
    <div id='habilidades' className="habilidades__div--container">
        <div className="habilidades__div--seccion-habilidades">
            <h2 className="habilidades__h2--habilidades">Habilidades</h2>
            <ul className="habilidades__ul--lista">
                <li>Programador web FrontEnd</li>
                <li>Programador web BackEnd</li>
                <li>Autodidacta</li>
            </ul>
        </div>
    </div>
    )
}
